<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-2">{{ "Movie Pass Sales" }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <!-- Transaction Date From-->
          <div class="col-lg-4 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  v-if="from_date"
                  v-on:click="clearDate('from_date')"
                  class="btn-clearDate"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="from_date"
                  name="selectenddate_1"
                  id="selectenddate_1"
                  v-validate="'required'"
                  :typeable="true"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="from_date ? 'active' : ''">{{
                  $t("fromdate")
                }}</label>
              </div>
            </div>
          </div>

          <!-- Transaction Date To -->
          <div class="col-lg-4 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  v-if="to_date"
                  v-on:click="clearDate('to_date')"
                  class="btn-clearDate"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="to_date"
                  name="selectenddate_3"
                  id="selectenddate_3"
                  v-validate="'required'"
                  :typeable="true"
                ></Datepicker>
                <label :class="to_date ? 'active' : ''">{{
                  $t("todate")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-3">
            <b-form-input
              v-model="searchValue"
              v-debounce:800="onSearch"
              placeholder="Search..."
            ></b-form-input>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              :disabled="btenable"
              @click.prevent.stop="getMoviePassSales"
              class="btn btn-primary w-50"
            >
              {{ $tc("fetch") }}
            </button>
          </div>

          <div class="col-xl-3 d-flex justify-content-end">
            <div class="mr-2">
              <b-dropdown id="listview" variant="outline-blue">
                <template v-slot:button-content>
                  Viewing&nbsp;
                  <strong>{{ selectedvalue }}</strong>
                  &nbsp;Of&nbsp;
                  <strong>{{ rows }}</strong>
                </template>
                <b-dropdown-item
                  v-for="(list, listIndex) in viewingnumbers"
                  :key="listIndex"
                  @click="onDropDownChangeValue(list.name)"
                  href="#"
                  >{{ list.name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>

            <div
              v-if="false"
              class="d-flex justify-content-end align-items-center"
            >
              <div class="mr-2">{{ $t("download") }} as:</div>
              <a :href="'#'" target="_blank" title="Download as Excel" download>
                <img
                  src="@/assets/img/icons/excel.svg"
                  height="25"
                  width="25"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="swc-report">
          <table class="swc-report-table mb-3" border="1">
            <thead style="background-color: #f5f5f7">
              <tr class="bg-lightgrey">
                <th>{{ $t("transaction_id") }}</th>
                <th>
                  {{ $tc("transaction") }} {{ $tc("date") }} & {{ $tc("time") }}
                </th>
                <th>Pass Name</th>
                <th>Pass UUID</th>
                <th>{{ $tc("customer") }} {{ $tc("name") }}</th>
                <th>{{ $tc("customer") }} {{ $tc("phone") }}</th>
                <th>{{ $tc("customer") }} {{ $tc("email") }}</th>
                <th>Payment Mode</th>
                <th>{{ $t("totalamount") }} <br /></th>
                <th>Operator</th>
              </tr>
            </thead>
            <tbody
              v-for="(passTrx, passTrxIndex) in MoviePassTransactions"
              :key="passTrxIndex"
              class="sph-report light_grey_back"
            >
              <tr>
                <td class="text-right">{{ passTrx.invoice_no || "-" }}</td>
                <td class="text-right">
                  {{ passTrx.booking_datetime | fulldatemonparse }}
                </td>
                <td class="text-right">{{ passTrx.pass_name || "-" }}</td>
                <td class="text-right">{{ passTrx.pass_uuid || "-" }}</td>
                <td class="text-left">
                  {{ passTrx.cust_name }}
                </td>
                <td class="text-right">
                  {{ passTrx.cust_mobile }}
                </td>
                <td class="text-right">
                  {{ passTrx.cust_email }}
                </td>
                <td class="text-right">
                  {{ passTrx.payment_mode_name }}
                </td>
                <td class="text-right">
                  {{ currFormat(passTrx.trx_gross_amount) }}
                </td>
                <td class="text-right">
                  {{ passTrx.username }}
                </td>
              </tr>
            </tbody>
            <tbody v-if="MoviePassTransactions.length == 0">
              <tr>
                <td colspan="16">
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <br />
      <b-pagination
        v-if="MoviePassTransactions.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
        class="my-3"
      ></b-pagination>
    </div>
    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>
  </div>
</template>
<script>
import moment from "moment-timezone";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import _ from "lodash";
import Printd from "printd";
import NoRecords from "@/components/Partials/NoRecords.vue";
import { createQueryString } from "@/services/ApiHelper";
import MarketingService from "@/services/MarketingService";

export default {
  components: { DatePicker, Multiselect, NoRecords },
  data() {
    return {
      from_date: moment().toDate(),
      to_date: new Date(),
      cinema_id: null,
      MoviePassTransactions: [],
      searchValue: "",
      btenable: false,
      isSearchLoading: false,
      selectedCinema: "",
      Cinemas: [],
      EjsData: null,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
    };
  },
  beforeMount() {
    // this.getMoviePassSales();
    this.getviewingnumber();
  },
  watch: {},
  computed: {},
  methods: {
    createQueryString,
    onSearch() {
      this.currentPage = 1;
      this.getMoviePassSales();
    },
    moment,
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getMoviePassSales();
      } else {
        this.currentPage = event;
        this.getMoviePassSales();
      }
    },
    clearDate(type) {
      this.currentPage = 1;
      this.MoviePassTransactions = [];
      switch (type) {
        case 1:
        case "from_date":
          this.from_date = "";
          break;
        case 2:
        case "to_date":
          this.to_date = "";
          break;
      }
    },
    debouncedOnChange: _.debounce(function (query) {
      this.MoviePassTransactions = [];
      this.currentPage = 1;
      this.getMoviePassSales();
    }, 500),

    onChangeDate: function (e, type) {
      if(type == 'from'){
        this.to_date = new Date(e);
        this.$$forceUpdate();
      }

    },
    getMoviePassSales: function () {
      if (!this.to_date && !this.from_date) {
        return this.$toasted.show("Please select Date");
      } else if (this.to_date && !this.from_date) {
        return this.$toasted.show("Please select From date");
      } else if (this.from_date && !this.to_date) {
        return this.$toasted.show("Please select TO date");
      } else if (moment(this.from_date).isAfter(this.to_date)) {
        return this.$toasted.show("From must be smaller than To Date");
      } else {
        let loader = this.$loading.show();
        this.MoviePassTransactions = [];
        this.btenable = true;
        let payload = {
          from_date: this.from_date
            ? moment(this.from_date).format("YYYY-MM-DD")
            : null,
          to_date: this.to_date
            ? moment(this.to_date).format("YYYY-MM-DD")
            : null,
          searchValue: this.searchValue,
          limit: this.perPage,
          currentPage: this.currentPage,
          cinema_id: null,
        };

        MarketingService.GetAllMoviePassSales(payload)
          .then((response) => {
            const { data } = response;
            if (
              data &&
              data.status &&
              data.Records &&
              data.Records.length > 0
            ) {
              this.MoviePassTransactions = data.Records;
              if (data.pagination.total) {
                this.rows = data.pagination.total;
              }
              this.selectedvalue = data.pagination.to - data.pagination.from;
            } else {
              this.MoviePassTransactions = [];
              this.selectedvalue = 0;
              this.rows = 0;
              this.$toasted.show(this.$t("No Records Found"));
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          })
          .finally(() => {
            this.btenable = false;
            setTimeout(() => loader.hide(), 1000);
          });
      }
    },
  },
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}

.color-box {
  width: 15px;
  height: 15px;
  margin-bottom: 10px;
}
.color-combination {
  font-size: 12px;
}

.fw-ms {
  font-family: Arial !important;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/MoviePass/MoviePassSales.vue